import { DropdownOption } from '@talentmesh/core';
import { RHFDropdown } from '@talentmesh/forms';
import React, { useEffect } from 'react';
import useTMTranslation, { TMTranslationGetter } from '../../../../../../Hooks/useTMTranslation';
import { CommonResourceKey } from '../../../../../../i18n/byNamespace/i18nCommonResourceKeys';
import ApplicantInformationType from '../../../../../../Models/ApplicantInformationType';
import { RecruitmentInformationFormValues, useRecruitmentInfoFormContext } from '../../RecruitmentInformationUtils';
import Constants from '../Constants';

type IsEmployedDropdownOptionsType = (t: TMTranslationGetter<CommonResourceKey>) => DropdownOption[];

const IsEmployedDropdownOptions: IsEmployedDropdownOptionsType = (t) => {
    return [
        { id: Constants.isEmployed, name: t('Yes') },
        { id: Constants.isUnemployed, name: t('No') },
    ];
};

const fieldsToReset: (keyof RecruitmentInformationFormValues)[] = ['ReasonForLeaving', 'NoticePeriod'];

function IsEmployedDropdown(): React.JSX.Element {
    const { watch, setValue } = useRecruitmentInfoFormContext();
    const IsEmployed = watch('IsEmployed');
    const { tCommon: t } = useTMTranslation();

    useEffect(() => {
        // Should reset only when transitioning from unemployed to employed
        if (IsEmployed === Constants.isUnemployed) {
            fieldsToReset.map((fieldName) => setValue(fieldName, ''));
        }
    }, [IsEmployed]);

    return (
        <RHFDropdown
            data-cy="IsEmployedDropdown"
            label={`${t('AreYouCurrentlyEmployed')}*`}
            name={ApplicantInformationType.IsEmployed}
            options={IsEmployedDropdownOptions(t)}
        />
    );
}

export default IsEmployedDropdown;
